import { IconicShieldTick } from '@insify/design-system/iconic-icons';
import { LogoWithText, LogoWithTextInverted } from '@insify/design-system/logo';
import { headingXs, textSm } from '@insify/design-system/typography';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { isActiveCoverage } from '../../../utils/policies';

import styles from './ProductCard.module.css';

import type { Bundle, CompanyBundle, Coverage, PersonalBundle } from '../../../types/Policy';
import type { ClassValue } from 'clsx';

interface Props {
  bundle: Bundle;
  className?: ClassValue;
  additionalContent?: React.ReactNode;
}

export const ProductCard: React.FC<Props> = ({ bundle, className, additionalContent }) => {
  const { t } = useTranslation('policy');
  return (
    <div data-hj-suppress className={clsx(styles.innerCard, styles[`${bundle.type}Card`], className)}>
      <div className={styles.cardImage} />
      <div className={`${styles.header} ${styles[`${bundle.type}Header`]}`}>
        <div className={styles.headerContent}>
          <h3 className={clsx(headingXs, styles.title)}>
            {t(`policy_type.${bundle.type === 'company' ? 'pnc' : 'disability'}`)}
          </h3>
          <p className={clsx(textSm, styles.name)}>
            {bundle.type === 'company' ? (bundle as CompanyBundle).companyName : (bundle as PersonalBundle).name}
          </p>
        </div>
        <div className={styles.logo}>
          {bundle.type === 'company' ? <LogoWithTextInverted width={100} /> : <LogoWithText width={100} />}
        </div>
      </div>
      <div className={styles.bottom}>{additionalContent}</div>
    </div>
  );
};

export const ProductStatus: React.FC<{ coverage: Coverage }> = ({ coverage }) => {
  const { t } = useTranslation('policy');

  return (
    <div className={styles.statusContainer}>
      <IconicShieldTick className={styles.icon} />
      <span className={styles.status}>{isActiveCoverage(coverage) ? t('active') : t('inactive')}</span>
    </div>
  );
};
